export const hashedApiKey = 'b5d6c983355d0566e35452ca653a9dc0e09c9dc6d88b3348de9f5af910762770'
// export const API_BASE_URL = "http://localhost:5000";
export const API_BASE_URL = "https://providerapi.senteez.com";